function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 135,
  r: 5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 134.27777777777777,
  r: 5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 133.55555555555554,
  r: 5
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 132.83333333333331,
  r: 5
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 132.11111111111111,
  r: 5
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 131.38888888888889,
  r: 5
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 130.66666666666669,
  r: 5
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 129.94444444444446,
  r: 5
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 129.22222222222223,
  r: 5
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 128.5,
  r: 5
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 127.77777777777777,
  r: 5
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 127.05555555555556,
  r: 5
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 126.33333333333334,
  r: 5
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 125.61111111111111,
  r: 5
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 124.88888888888889,
  r: 5
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 124.16666666666667,
  r: 5
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 123.44444444444444,
  r: 5
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 122.72222222222223,
  r: 5
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 122,
  r: 5
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 121.27777777777777,
  r: 5
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 120.55555555555556,
  r: 5
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 119.83333333333333,
  r: 5
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 119.11111111111111,
  r: 5
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 118.38888888888889,
  r: 5
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 117.66666666666667,
  r: 5
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 116.94444444444444,
  r: 5
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 116.22222222222223,
  r: 5
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 115.5,
  r: 5
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 114.77777777777777,
  r: 5
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 114.05555555555556,
  r: 5
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 113.33333333333334,
  r: 5
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 112.61111111111111,
  r: 5
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 111.88888888888889,
  r: 5
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 111.16666666666666,
  r: 5
});

var _ref36 = /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 110.44444444444444,
  r: 5
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 109.72222222222223,
  r: 5
});

var _ref38 = /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 109,
  r: 5
});

var _ref39 = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 108.27777777777777,
  r: 5
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 107.55555555555556,
  r: 5
});

var _ref41 = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 106.83333333333333,
  r: 5
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 106.11111111111111,
  r: 5
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 105.38888888888889,
  r: 5
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 104.66666666666667,
  r: 5
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 103.94444444444444,
  r: 5
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 103.22222222222223,
  r: 5
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 102.5,
  r: 5
});

var _ref48 = /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 101.77777777777777,
  r: 5
});

var _ref49 = /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 101.05555555555554,
  r: 5
});

var _ref50 = /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 100.33333333333334,
  r: 5
});

var _ref51 = /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 99.61111111111111,
  r: 5
});

var _ref52 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 98.88888888888889,
  r: 5
});

var _ref53 = /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 98.16666666666666,
  r: 5
});

var _ref54 = /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 97.44444444444446,
  r: 5
});

var _ref55 = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 96.72222222222223,
  r: 5
});

var _ref56 = /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 96,
  r: 5
});

var _ref57 = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 95.27777777777777,
  r: 5
});

var _ref58 = /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 94.55555555555556,
  r: 5
});

var _ref59 = /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 93.83333333333334,
  r: 5
});

var _ref60 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 93.11111111111111,
  r: 5
});

var _ref61 = /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 92.38888888888889,
  r: 5
});

var _ref62 = /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 91.66666666666667,
  r: 5
});

var _ref63 = /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 90.94444444444444,
  r: 5
});

var _ref64 = /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 90.22222222222223,
  r: 5
});

var _ref65 = /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 89.5,
  r: 5
});

var _ref66 = /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 88.77777777777777,
  r: 5
});

var _ref67 = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 88.05555555555556,
  r: 5
});

var _ref68 = /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 87.33333333333334,
  r: 5
});

var _ref69 = /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 86.61111111111111,
  r: 5
});

var _ref70 = /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 85.88888888888889,
  r: 5
});

var _ref71 = /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 85.16666666666666,
  r: 5
});

var _ref72 = /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 84.44444444444444,
  r: 5
});

var _ref73 = /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 83.72222222222223,
  r: 5
});

var _ref74 = /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 83,
  r: 5
});

var _ref75 = /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 82.27777777777777,
  r: 5
});

var _ref76 = /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 81.55555555555556,
  r: 5
});

var _ref77 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 80.83333333333333,
  r: 5
});

var _ref78 = /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 80.11111111111111,
  r: 5
});

var _ref79 = /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 79.38888888888889,
  r: 5
});

var _ref80 = /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 78.66666666666666,
  r: 5
});

var _ref81 = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 77.94444444444444,
  r: 5
});

var _ref82 = /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 77.22222222222223,
  r: 5
});

var _ref83 = /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 76.5,
  r: 5
});

var _ref84 = /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 75.77777777777777,
  r: 5
});

var _ref85 = /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 75.05555555555554,
  r: 5
});

var _ref86 = /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 74.33333333333334,
  r: 5
});

var _ref87 = /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 73.61111111111111,
  r: 5
});

var _ref88 = /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 72.88888888888889,
  r: 5
});

var _ref89 = /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 72.16666666666666,
  r: 5
});

var _ref90 = /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 71.44444444444446,
  r: 5
});

var _ref91 = /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 70.72222222222221,
  r: 5
});

var _ref92 = /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 70,
  r: 5
});

var _ref93 = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 69.27777777777779,
  r: 5
});

var _ref94 = /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 68.55555555555556,
  r: 5
});

var _ref95 = /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 67.83333333333333,
  r: 5
});

var _ref96 = /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 67.1111111111111,
  r: 5
});

var _ref97 = /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 66.38888888888889,
  r: 5
});

var _ref98 = /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 65.66666666666667,
  r: 5
});

var _ref99 = /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 64.94444444444444,
  r: 5
});

var _ref100 = /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 64.22222222222223,
  r: 5
});

var _ref101 = /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 63.5,
  r: 5
});

var _ref102 = /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 62.77777777777777,
  r: 5
});

var _ref103 = /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 62.05555555555556,
  r: 5
});

var _ref104 = /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 61.33333333333333,
  r: 5
});

var _ref105 = /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 60.611111111111114,
  r: 5
});

var _ref106 = /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 59.8888888888889,
  r: 5
});

var _ref107 = /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 59.16666666666666,
  r: 5
});

var _ref108 = /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 58.44444444444444,
  r: 5
});

var _ref109 = /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 57.72222222222223,
  r: 5
});

var _ref110 = /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 57,
  r: 5
});

var _ref111 = /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 56.277777777777786,
  r: 5
});

var _ref112 = /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 55.55555555555554,
  r: 5
});

var _ref113 = /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 54.83333333333333,
  r: 5
});

var _ref114 = /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 54.111111111111114,
  r: 5
});

var _ref115 = /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 53.388888888888886,
  r: 5
});

var _ref116 = /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 52.66666666666667,
  r: 5
});

var _ref117 = /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 51.94444444444446,
  r: 5
});

var _ref118 = /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 51.222222222222214,
  r: 5
});

var _ref119 = /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 50.5,
  r: 5
});

var _ref120 = /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 49.77777777777777,
  r: 5
});

var _ref121 = /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 49.05555555555556,
  r: 5
});

var _ref122 = /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 48.33333333333334,
  r: 5
});

var _ref123 = /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 47.6111111111111,
  r: 5
});

var _ref124 = /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 46.888888888888886,
  r: 5
});

var _ref125 = /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 46.16666666666667,
  r: 5
});

var _ref126 = /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 45.44444444444444,
  r: 5
});

var _ref127 = /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 44.72222222222223,
  r: 5
});

var _ref128 = /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 44,
  r: 5
});

var _ref129 = /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 43.27777777777777,
  r: 5
});

var _ref130 = /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 42.55555555555556,
  r: 5
});

var _ref131 = /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 41.83333333333333,
  r: 5
});

var _ref132 = /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 41.111111111111114,
  r: 5
});

var _ref133 = /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 40.3888888888889,
  r: 5
});

var _ref134 = /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 39.66666666666667,
  r: 5
});

var _ref135 = /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 38.94444444444444,
  r: 5
});

var _ref136 = /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 38.222222222222214,
  r: 5
});

var _ref137 = /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 37.5,
  r: 5
});

var _ref138 = /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 36.777777777777786,
  r: 5
});

var _ref139 = /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 36.05555555555556,
  r: 5
});

var _ref140 = /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 35.33333333333333,
  r: 5
});

var _ref141 = /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 34.6111111111111,
  r: 5
});

var _ref142 = /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 33.888888888888886,
  r: 5
});

var _ref143 = /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 33.16666666666667,
  r: 5
});

var _ref144 = /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 32.44444444444444,
  r: 5
});

var _ref145 = /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 31.72222222222223,
  r: 5
});

var _ref146 = /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 31,
  r: 5
});

var _ref147 = /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 30.27777777777777,
  r: 5
});

var _ref148 = /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 29.555555555555557,
  r: 5
});

var _ref149 = /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 28.83333333333333,
  r: 5
});

var _ref150 = /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 28.111111111111114,
  r: 5
});

var _ref151 = /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 27.3888888888889,
  r: 5
});

var _ref152 = /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 26.666666666666657,
  r: 5
});

var _ref153 = /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 25.944444444444443,
  r: 5
});

var _ref154 = /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 25.22222222222223,
  r: 5
});

var _ref155 = /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 24.5,
  r: 5
});

var _ref156 = /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 23.777777777777786,
  r: 5
});

var _ref157 = /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 23.055555555555543,
  r: 5
});

var _ref158 = /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 22.33333333333333,
  r: 5
});

var _ref159 = /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 21.611111111111114,
  r: 5
});

var _ref160 = /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 20.888888888888886,
  r: 5
});

var _ref161 = /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 20.16666666666667,
  r: 5
});

var _ref162 = /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 19.444444444444457,
  r: 5
});

var _ref163 = /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 18.722222222222214,
  r: 5
});

var _ref164 = /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 18,
  r: 5
});

var _ref165 = /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 17.27777777777777,
  r: 5
});

var _ref166 = /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 16.555555555555557,
  r: 5
});

var _ref167 = /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 15.833333333333343,
  r: 5
});

var _ref168 = /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 15.1111111111111,
  r: 5
});

var _ref169 = /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 14.388888888888886,
  r: 5
});

var _ref170 = /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 13.666666666666671,
  r: 5
});

var _ref171 = /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 12.944444444444443,
  r: 5
});

var _ref172 = /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 12.222222222222229,
  r: 5
});

var _ref173 = /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 11.5,
  r: 5
});

var _ref174 = /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 10.777777777777771,
  r: 5
});

var _ref175 = /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 10.055555555555557,
  r: 5
});

var _ref176 = /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 9.333333333333329,
  r: 5
});

var _ref177 = /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 8.611111111111114,
  r: 5
});

var _ref178 = /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 7.8888888888889,
  r: 5
});

var _ref179 = /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 7.166666666666671,
  r: 5
});

var _ref180 = /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 6.444444444444429,
  r: 5
});

var _ref181 = /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 5.7222222222222285,
  r: 5
});

var _ref182 = /*#__PURE__*/React.createElement("line", {
  x1: 185,
  y1: 5.7222222222222285,
  x2: 185,
  y2: 135,
  stroke: "#000",
  strokeWidth: 11
});

var _ref183 = /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 134.27777777777777,
  r: 5
});

var _ref184 = /*#__PURE__*/React.createElement("circle", {
  cx: 187,
  cy: 133.55555555555554,
  r: 5
});

var _ref185 = /*#__PURE__*/React.createElement("circle", {
  cx: 188,
  cy: 132.83333333333331,
  r: 5
});

var _ref186 = /*#__PURE__*/React.createElement("circle", {
  cx: 189,
  cy: 132.11111111111111,
  r: 5
});

var _ref187 = /*#__PURE__*/React.createElement("circle", {
  cx: 190,
  cy: 131.38888888888889,
  r: 5
});

var _ref188 = /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 130.66666666666669,
  r: 5
});

var _ref189 = /*#__PURE__*/React.createElement("circle", {
  cx: 192,
  cy: 129.94444444444446,
  r: 5
});

var _ref190 = /*#__PURE__*/React.createElement("circle", {
  cx: 193,
  cy: 129.22222222222223,
  r: 5
});

var _ref191 = /*#__PURE__*/React.createElement("circle", {
  cx: 194,
  cy: 128.5,
  r: 5
});

var _ref192 = /*#__PURE__*/React.createElement("circle", {
  cx: 195,
  cy: 127.77777777777777,
  r: 5
});

var _ref193 = /*#__PURE__*/React.createElement("circle", {
  cx: 196,
  cy: 127.05555555555556,
  r: 5
});

var _ref194 = /*#__PURE__*/React.createElement("circle", {
  cx: 197,
  cy: 126.33333333333334,
  r: 5
});

var _ref195 = /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 125.61111111111111,
  r: 5
});

var _ref196 = /*#__PURE__*/React.createElement("circle", {
  cx: 199,
  cy: 124.88888888888889,
  r: 5
});

var _ref197 = /*#__PURE__*/React.createElement("circle", {
  cx: 200,
  cy: 124.16666666666667,
  r: 5
});

var _ref198 = /*#__PURE__*/React.createElement("circle", {
  cx: 201,
  cy: 123.44444444444444,
  r: 5
});

var _ref199 = /*#__PURE__*/React.createElement("circle", {
  cx: 202,
  cy: 122.72222222222223,
  r: 5
});

var _ref200 = /*#__PURE__*/React.createElement("circle", {
  cx: 203,
  cy: 122,
  r: 5
});

var _ref201 = /*#__PURE__*/React.createElement("circle", {
  cx: 204,
  cy: 121.27777777777777,
  r: 5
});

var _ref202 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 120.55555555555556,
  r: 5
});

var _ref203 = /*#__PURE__*/React.createElement("circle", {
  cx: 206,
  cy: 119.83333333333333,
  r: 5
});

var _ref204 = /*#__PURE__*/React.createElement("circle", {
  cx: 207,
  cy: 119.11111111111111,
  r: 5
});

var _ref205 = /*#__PURE__*/React.createElement("circle", {
  cx: 208,
  cy: 118.38888888888889,
  r: 5
});

var _ref206 = /*#__PURE__*/React.createElement("circle", {
  cx: 209,
  cy: 117.66666666666667,
  r: 5
});

var _ref207 = /*#__PURE__*/React.createElement("circle", {
  cx: 210,
  cy: 116.94444444444444,
  r: 5
});

var _ref208 = /*#__PURE__*/React.createElement("circle", {
  cx: 211,
  cy: 116.22222222222223,
  r: 5
});

var _ref209 = /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 115.5,
  r: 5
});

var _ref210 = /*#__PURE__*/React.createElement("circle", {
  cx: 213,
  cy: 114.77777777777777,
  r: 5
});

var _ref211 = /*#__PURE__*/React.createElement("circle", {
  cx: 214,
  cy: 114.05555555555556,
  r: 5
});

var _ref212 = /*#__PURE__*/React.createElement("circle", {
  cx: 215,
  cy: 113.33333333333334,
  r: 5
});

var _ref213 = /*#__PURE__*/React.createElement("circle", {
  cx: 216,
  cy: 112.61111111111111,
  r: 5
});

var _ref214 = /*#__PURE__*/React.createElement("circle", {
  cx: 217,
  cy: 111.88888888888889,
  r: 5
});

var _ref215 = /*#__PURE__*/React.createElement("circle", {
  cx: 218,
  cy: 111.16666666666666,
  r: 5
});

var _ref216 = /*#__PURE__*/React.createElement("circle", {
  cx: 219,
  cy: 110.44444444444444,
  r: 5
});

var _ref217 = /*#__PURE__*/React.createElement("circle", {
  cx: 220,
  cy: 109.72222222222223,
  r: 5
});

var _ref218 = /*#__PURE__*/React.createElement("circle", {
  cx: 221,
  cy: 109,
  r: 5
});

var _ref219 = /*#__PURE__*/React.createElement("circle", {
  cx: 222,
  cy: 108.27777777777777,
  r: 5
});

var _ref220 = /*#__PURE__*/React.createElement("circle", {
  cx: 223,
  cy: 107.55555555555556,
  r: 5
});

var _ref221 = /*#__PURE__*/React.createElement("circle", {
  cx: 224,
  cy: 106.83333333333333,
  r: 5
});

var _ref222 = /*#__PURE__*/React.createElement("circle", {
  cx: 225,
  cy: 106.11111111111111,
  r: 5
});

var _ref223 = /*#__PURE__*/React.createElement("circle", {
  cx: 226,
  cy: 105.38888888888889,
  r: 5
});

var _ref224 = /*#__PURE__*/React.createElement("circle", {
  cx: 227,
  cy: 104.66666666666667,
  r: 5
});

var _ref225 = /*#__PURE__*/React.createElement("circle", {
  cx: 228,
  cy: 103.94444444444444,
  r: 5
});

var _ref226 = /*#__PURE__*/React.createElement("circle", {
  cx: 229,
  cy: 103.22222222222223,
  r: 5
});

var _ref227 = /*#__PURE__*/React.createElement("circle", {
  cx: 230,
  cy: 102.5,
  r: 5
});

var _ref228 = /*#__PURE__*/React.createElement("circle", {
  cx: 231,
  cy: 101.77777777777777,
  r: 5
});

var _ref229 = /*#__PURE__*/React.createElement("circle", {
  cx: 232,
  cy: 101.05555555555554,
  r: 5
});

var _ref230 = /*#__PURE__*/React.createElement("circle", {
  cx: 233,
  cy: 100.33333333333334,
  r: 5
});

var _ref231 = /*#__PURE__*/React.createElement("circle", {
  cx: 234,
  cy: 99.61111111111111,
  r: 5
});

var _ref232 = /*#__PURE__*/React.createElement("circle", {
  cx: 235,
  cy: 98.88888888888889,
  r: 5
});

var _ref233 = /*#__PURE__*/React.createElement("circle", {
  cx: 236,
  cy: 98.16666666666666,
  r: 5
});

var _ref234 = /*#__PURE__*/React.createElement("circle", {
  cx: 237,
  cy: 97.44444444444446,
  r: 5
});

var _ref235 = /*#__PURE__*/React.createElement("circle", {
  cx: 238,
  cy: 96.72222222222223,
  r: 5
});

var _ref236 = /*#__PURE__*/React.createElement("circle", {
  cx: 239,
  cy: 96,
  r: 5
});

var _ref237 = /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 95.27777777777777,
  r: 5
});

var _ref238 = /*#__PURE__*/React.createElement("circle", {
  cx: 241,
  cy: 94.55555555555556,
  r: 5
});

var _ref239 = /*#__PURE__*/React.createElement("circle", {
  cx: 242,
  cy: 93.83333333333334,
  r: 5
});

var _ref240 = /*#__PURE__*/React.createElement("circle", {
  cx: 243,
  cy: 93.11111111111111,
  r: 5
});

var _ref241 = /*#__PURE__*/React.createElement("circle", {
  cx: 244,
  cy: 92.38888888888889,
  r: 5
});

var _ref242 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 91.66666666666667,
  r: 5
});

var _ref243 = /*#__PURE__*/React.createElement("circle", {
  cx: 246,
  cy: 90.94444444444444,
  r: 5
});

var _ref244 = /*#__PURE__*/React.createElement("circle", {
  cx: 247,
  cy: 90.22222222222223,
  r: 5
});

var _ref245 = /*#__PURE__*/React.createElement("circle", {
  cx: 248,
  cy: 89.5,
  r: 5
});

var _ref246 = /*#__PURE__*/React.createElement("circle", {
  cx: 249,
  cy: 88.77777777777777,
  r: 5
});

var _ref247 = /*#__PURE__*/React.createElement("circle", {
  cx: 250,
  cy: 88.05555555555556,
  r: 5
});

var _ref248 = /*#__PURE__*/React.createElement("circle", {
  cx: 251,
  cy: 87.33333333333334,
  r: 5
});

var _ref249 = /*#__PURE__*/React.createElement("circle", {
  cx: 252,
  cy: 86.61111111111111,
  r: 5
});

var _ref250 = /*#__PURE__*/React.createElement("circle", {
  cx: 253,
  cy: 85.88888888888889,
  r: 5
});

var _ref251 = /*#__PURE__*/React.createElement("circle", {
  cx: 254,
  cy: 85.16666666666666,
  r: 5
});

var _ref252 = /*#__PURE__*/React.createElement("circle", {
  cx: 255,
  cy: 84.44444444444444,
  r: 5
});

var _ref253 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 83.72222222222223,
  r: 5
});

var _ref254 = /*#__PURE__*/React.createElement("circle", {
  cx: 257,
  cy: 83,
  r: 5
});

var _ref255 = /*#__PURE__*/React.createElement("circle", {
  cx: 258,
  cy: 82.27777777777777,
  r: 5
});

var _ref256 = /*#__PURE__*/React.createElement("circle", {
  cx: 259,
  cy: 81.55555555555556,
  r: 5
});

var _ref257 = /*#__PURE__*/React.createElement("circle", {
  cx: 260,
  cy: 80.83333333333333,
  r: 5
});

var _ref258 = /*#__PURE__*/React.createElement("circle", {
  cx: 261,
  cy: 80.11111111111111,
  r: 5
});

var _ref259 = /*#__PURE__*/React.createElement("circle", {
  cx: 262,
  cy: 79.38888888888889,
  r: 5
});

var _ref260 = /*#__PURE__*/React.createElement("circle", {
  cx: 263,
  cy: 78.66666666666666,
  r: 5
});

var _ref261 = /*#__PURE__*/React.createElement("circle", {
  cx: 264,
  cy: 77.94444444444444,
  r: 5
});

var _ref262 = /*#__PURE__*/React.createElement("circle", {
  cx: 265,
  cy: 77.22222222222223,
  r: 5
});

var _ref263 = /*#__PURE__*/React.createElement("circle", {
  cx: 266,
  cy: 76.5,
  r: 5
});

var _ref264 = /*#__PURE__*/React.createElement("circle", {
  cx: 267,
  cy: 75.77777777777777,
  r: 5
});

var _ref265 = /*#__PURE__*/React.createElement("circle", {
  cx: 268,
  cy: 75.05555555555554,
  r: 5
});

var _ref266 = /*#__PURE__*/React.createElement("circle", {
  cx: 269,
  cy: 74.33333333333334,
  r: 5
});

var _ref267 = /*#__PURE__*/React.createElement("circle", {
  cx: 270,
  cy: 73.61111111111111,
  r: 5
});

var _ref268 = /*#__PURE__*/React.createElement("circle", {
  cx: 271,
  cy: 72.88888888888889,
  r: 5
});

var _ref269 = /*#__PURE__*/React.createElement("circle", {
  cx: 272,
  cy: 72.16666666666666,
  r: 5
});

var _ref270 = /*#__PURE__*/React.createElement("circle", {
  cx: 273,
  cy: 71.44444444444446,
  r: 5
});

var _ref271 = /*#__PURE__*/React.createElement("circle", {
  cx: 274,
  cy: 70.72222222222221,
  r: 5
});

var _ref272 = /*#__PURE__*/React.createElement("circle", {
  cx: 275,
  cy: 70,
  r: 5
});

var _ref273 = /*#__PURE__*/React.createElement("circle", {
  cx: 276,
  cy: 69.27777777777779,
  r: 5
});

var _ref274 = /*#__PURE__*/React.createElement("circle", {
  cx: 277,
  cy: 68.55555555555556,
  r: 5
});

var _ref275 = /*#__PURE__*/React.createElement("circle", {
  cx: 278,
  cy: 67.83333333333333,
  r: 5
});

var _ref276 = /*#__PURE__*/React.createElement("circle", {
  cx: 279,
  cy: 67.1111111111111,
  r: 5
});

var _ref277 = /*#__PURE__*/React.createElement("circle", {
  cx: 280,
  cy: 66.38888888888889,
  r: 5
});

var _ref278 = /*#__PURE__*/React.createElement("circle", {
  cx: 281,
  cy: 65.66666666666667,
  r: 5
});

var _ref279 = /*#__PURE__*/React.createElement("circle", {
  cx: 282,
  cy: 64.94444444444444,
  r: 5
});

var _ref280 = /*#__PURE__*/React.createElement("circle", {
  cx: 283,
  cy: 64.22222222222223,
  r: 5
});

var _ref281 = /*#__PURE__*/React.createElement("circle", {
  cx: 284,
  cy: 63.5,
  r: 5
});

var _ref282 = /*#__PURE__*/React.createElement("circle", {
  cx: 285,
  cy: 62.77777777777777,
  r: 5
});

var _ref283 = /*#__PURE__*/React.createElement("circle", {
  cx: 286,
  cy: 62.05555555555556,
  r: 5
});

var _ref284 = /*#__PURE__*/React.createElement("circle", {
  cx: 287,
  cy: 61.33333333333333,
  r: 5
});

var _ref285 = /*#__PURE__*/React.createElement("circle", {
  cx: 288,
  cy: 60.611111111111114,
  r: 5
});

var _ref286 = /*#__PURE__*/React.createElement("circle", {
  cx: 289,
  cy: 59.8888888888889,
  r: 5
});

var _ref287 = /*#__PURE__*/React.createElement("circle", {
  cx: 290,
  cy: 59.16666666666666,
  r: 5
});

var _ref288 = /*#__PURE__*/React.createElement("circle", {
  cx: 291,
  cy: 58.44444444444444,
  r: 5
});

var _ref289 = /*#__PURE__*/React.createElement("circle", {
  cx: 292,
  cy: 57.72222222222223,
  r: 5
});

var _ref290 = /*#__PURE__*/React.createElement("circle", {
  cx: 293,
  cy: 57,
  r: 5
});

var _ref291 = /*#__PURE__*/React.createElement("circle", {
  cx: 294,
  cy: 56.277777777777786,
  r: 5
});

var _ref292 = /*#__PURE__*/React.createElement("circle", {
  cx: 295,
  cy: 55.55555555555554,
  r: 5
});

var _ref293 = /*#__PURE__*/React.createElement("circle", {
  cx: 296,
  cy: 54.83333333333333,
  r: 5
});

var _ref294 = /*#__PURE__*/React.createElement("circle", {
  cx: 297,
  cy: 54.111111111111114,
  r: 5
});

var _ref295 = /*#__PURE__*/React.createElement("circle", {
  cx: 298,
  cy: 53.388888888888886,
  r: 5
});

var _ref296 = /*#__PURE__*/React.createElement("circle", {
  cx: 299,
  cy: 52.66666666666667,
  r: 5
});

var _ref297 = /*#__PURE__*/React.createElement("circle", {
  cx: 300,
  cy: 51.94444444444446,
  r: 5
});

var _ref298 = /*#__PURE__*/React.createElement("circle", {
  cx: 301,
  cy: 51.222222222222214,
  r: 5
});

var _ref299 = /*#__PURE__*/React.createElement("circle", {
  cx: 302,
  cy: 50.5,
  r: 5
});

var _ref300 = /*#__PURE__*/React.createElement("circle", {
  cx: 303,
  cy: 49.77777777777777,
  r: 5
});

var _ref301 = /*#__PURE__*/React.createElement("circle", {
  cx: 304,
  cy: 49.05555555555556,
  r: 5
});

var _ref302 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 48.33333333333334,
  r: 5
});

var _ref303 = /*#__PURE__*/React.createElement("circle", {
  cx: 306,
  cy: 47.6111111111111,
  r: 5
});

var _ref304 = /*#__PURE__*/React.createElement("circle", {
  cx: 307,
  cy: 46.888888888888886,
  r: 5
});

var _ref305 = /*#__PURE__*/React.createElement("circle", {
  cx: 308,
  cy: 46.16666666666667,
  r: 5
});

var _ref306 = /*#__PURE__*/React.createElement("circle", {
  cx: 309,
  cy: 45.44444444444444,
  r: 5
});

var _ref307 = /*#__PURE__*/React.createElement("circle", {
  cx: 310,
  cy: 44.72222222222223,
  r: 5
});

var _ref308 = /*#__PURE__*/React.createElement("circle", {
  cx: 311,
  cy: 44,
  r: 5
});

var _ref309 = /*#__PURE__*/React.createElement("circle", {
  cx: 312,
  cy: 43.27777777777777,
  r: 5
});

var _ref310 = /*#__PURE__*/React.createElement("circle", {
  cx: 313,
  cy: 42.55555555555556,
  r: 5
});

var _ref311 = /*#__PURE__*/React.createElement("circle", {
  cx: 314,
  cy: 41.83333333333333,
  r: 5
});

var _ref312 = /*#__PURE__*/React.createElement("circle", {
  cx: 315,
  cy: 41.111111111111114,
  r: 5
});

var _ref313 = /*#__PURE__*/React.createElement("circle", {
  cx: 316,
  cy: 40.3888888888889,
  r: 5
});

var _ref314 = /*#__PURE__*/React.createElement("circle", {
  cx: 317,
  cy: 39.66666666666667,
  r: 5
});

var _ref315 = /*#__PURE__*/React.createElement("circle", {
  cx: 318,
  cy: 38.94444444444444,
  r: 5
});

var _ref316 = /*#__PURE__*/React.createElement("circle", {
  cx: 319,
  cy: 38.222222222222214,
  r: 5
});

var _ref317 = /*#__PURE__*/React.createElement("circle", {
  cx: 320,
  cy: 37.5,
  r: 5
});

var _ref318 = /*#__PURE__*/React.createElement("circle", {
  cx: 321,
  cy: 36.777777777777786,
  r: 5
});

var _ref319 = /*#__PURE__*/React.createElement("circle", {
  cx: 322,
  cy: 36.05555555555556,
  r: 5
});

var _ref320 = /*#__PURE__*/React.createElement("circle", {
  cx: 323,
  cy: 35.33333333333333,
  r: 5
});

var _ref321 = /*#__PURE__*/React.createElement("circle", {
  cx: 324,
  cy: 34.6111111111111,
  r: 5
});

var _ref322 = /*#__PURE__*/React.createElement("circle", {
  cx: 325,
  cy: 33.888888888888886,
  r: 5
});

var _ref323 = /*#__PURE__*/React.createElement("circle", {
  cx: 326,
  cy: 33.16666666666667,
  r: 5
});

var _ref324 = /*#__PURE__*/React.createElement("circle", {
  cx: 327,
  cy: 32.44444444444444,
  r: 5
});

var _ref325 = /*#__PURE__*/React.createElement("circle", {
  cx: 328,
  cy: 31.72222222222223,
  r: 5
});

var _ref326 = /*#__PURE__*/React.createElement("circle", {
  cx: 329,
  cy: 31,
  r: 5
});

var _ref327 = /*#__PURE__*/React.createElement("circle", {
  cx: 330,
  cy: 30.27777777777777,
  r: 5
});

var _ref328 = /*#__PURE__*/React.createElement("circle", {
  cx: 331,
  cy: 29.555555555555557,
  r: 5
});

var _ref329 = /*#__PURE__*/React.createElement("circle", {
  cx: 332,
  cy: 28.83333333333333,
  r: 5
});

var _ref330 = /*#__PURE__*/React.createElement("circle", {
  cx: 333,
  cy: 28.111111111111114,
  r: 5
});

var _ref331 = /*#__PURE__*/React.createElement("circle", {
  cx: 334,
  cy: 27.3888888888889,
  r: 5
});

var _ref332 = /*#__PURE__*/React.createElement("circle", {
  cx: 335,
  cy: 26.666666666666657,
  r: 5
});

var _ref333 = /*#__PURE__*/React.createElement("circle", {
  cx: 336,
  cy: 25.944444444444443,
  r: 5
});

var _ref334 = /*#__PURE__*/React.createElement("circle", {
  cx: 337,
  cy: 25.22222222222223,
  r: 5
});

var _ref335 = /*#__PURE__*/React.createElement("circle", {
  cx: 338,
  cy: 24.5,
  r: 5
});

var _ref336 = /*#__PURE__*/React.createElement("circle", {
  cx: 339,
  cy: 23.777777777777786,
  r: 5
});

var _ref337 = /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 23.055555555555543,
  r: 5
});

var _ref338 = /*#__PURE__*/React.createElement("circle", {
  cx: 341,
  cy: 22.33333333333333,
  r: 5
});

var _ref339 = /*#__PURE__*/React.createElement("circle", {
  cx: 342,
  cy: 21.611111111111114,
  r: 5
});

var _ref340 = /*#__PURE__*/React.createElement("circle", {
  cx: 343,
  cy: 20.888888888888886,
  r: 5
});

var _ref341 = /*#__PURE__*/React.createElement("circle", {
  cx: 344,
  cy: 20.16666666666667,
  r: 5
});

var _ref342 = /*#__PURE__*/React.createElement("circle", {
  cx: 345,
  cy: 19.444444444444457,
  r: 5
});

var _ref343 = /*#__PURE__*/React.createElement("circle", {
  cx: 346,
  cy: 18.722222222222214,
  r: 5
});

var _ref344 = /*#__PURE__*/React.createElement("circle", {
  cx: 347,
  cy: 18,
  r: 5
});

var _ref345 = /*#__PURE__*/React.createElement("circle", {
  cx: 348,
  cy: 17.27777777777777,
  r: 5
});

var _ref346 = /*#__PURE__*/React.createElement("circle", {
  cx: 349,
  cy: 16.555555555555557,
  r: 5
});

var _ref347 = /*#__PURE__*/React.createElement("circle", {
  cx: 350,
  cy: 15.833333333333343,
  r: 5
});

var _ref348 = /*#__PURE__*/React.createElement("circle", {
  cx: 351,
  cy: 15.1111111111111,
  r: 5
});

var _ref349 = /*#__PURE__*/React.createElement("circle", {
  cx: 352,
  cy: 14.388888888888886,
  r: 5
});

var _ref350 = /*#__PURE__*/React.createElement("circle", {
  cx: 353,
  cy: 13.666666666666671,
  r: 5
});

var _ref351 = /*#__PURE__*/React.createElement("circle", {
  cx: 354,
  cy: 12.944444444444443,
  r: 5
});

var _ref352 = /*#__PURE__*/React.createElement("circle", {
  cx: 355,
  cy: 12.222222222222229,
  r: 5
});

var _ref353 = /*#__PURE__*/React.createElement("circle", {
  cx: 356,
  cy: 11.5,
  r: 5
});

var _ref354 = /*#__PURE__*/React.createElement("circle", {
  cx: 357,
  cy: 10.777777777777771,
  r: 5
});

var _ref355 = /*#__PURE__*/React.createElement("circle", {
  cx: 358,
  cy: 10.055555555555557,
  r: 5
});

var _ref356 = /*#__PURE__*/React.createElement("circle", {
  cx: 359,
  cy: 9.333333333333329,
  r: 5
});

var _ref357 = /*#__PURE__*/React.createElement("circle", {
  cx: 360,
  cy: 8.611111111111114,
  r: 5
});

var _ref358 = /*#__PURE__*/React.createElement("circle", {
  cx: 361,
  cy: 7.8888888888889,
  r: 5
});

var _ref359 = /*#__PURE__*/React.createElement("circle", {
  cx: 362,
  cy: 7.166666666666671,
  r: 5
});

var _ref360 = /*#__PURE__*/React.createElement("circle", {
  cx: 363,
  cy: 6.444444444444429,
  r: 5
});

var _ref361 = /*#__PURE__*/React.createElement("circle", {
  cx: 364,
  cy: 5.7222222222222285,
  r: 5
});

var _ref362 = /*#__PURE__*/React.createElement("line", {
  x1: 365,
  y1: 5.7222222222222285,
  x2: 365,
  y2: 135,
  stroke: "#000",
  strokeWidth: 11
});

var SvgSaw = function SvgSaw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 370 140",
    className: "wave-symbol",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saw.6a47fd34.svg";
export { ForwardRef as ReactComponent };